var map = {
	"./ampulheta.png": "3df3",
	"./check.png": "f0c8",
	"./close.png": "cd5c",
	"./google.png": "cebc",
	"./logo.png": "cf05",
	"./nameLogo.png": "8ade",
	"./refresh.png": "684f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";